/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum SignerContactType {
    SMS = 'sms',
    EMAIL = 'email',
}
